const Config = {
  EMAIL_FLOWS: {
    key: 'EMAIL_FLOWS',
    name: 'Email Flows',
  },
};

export default Config;
